// WARNING: these values are also used as storage key
export enum TimerType {
    INITIAL_LOGIN = 'initial_login_time',
    LAST_PURCHASE = 'last_purchase_time',
    HARVEST = 'harvest_time',
    SEND_GIFT_REQUEST_DATE = 'SendGiftRequestDate',
    // FIXME: it has same value as `GIFT_DATE`
    GIFT = 'GiftDate',
    LAST_LOGIN = 'last_login',
    SPIN_WHEEL = 'free_spin_time',
    // FIXME: it has same value as `GIFT`
    GIFT_DATE = 'GiftDate',
    LAST_LOGIN_WEEK = 'last_login_week',
    FOX_DATE = 'foxDate',
    SHOP_GIFT = 'shop_gift_time',
    AD_COOLDOWN = 'ad_cooldown_time',
    DYNAMIC_HELPER_AI = 'dynamic_helper_ai_time',
    STARTER_PACK_OFFER_SHOWN = 'v1.49.0_starter_pack_shown_time',
    PAYER_REACTIVATION_OFFER_START = 'payer_reactivation_offer_shown_time',
    FARM_MINI_GAME = 'farm_mini_game',

    /**
     * @deprecated Old SOLI mission timer
     */
    MISSION = 'mission_time',
    /**
     * @deprecated Old SOLI key mission timer
     */
    KEY_MISSION = 'key_mission_time',
}
